/**
 * Detecção de ambiente de desenvolvimento pelo hostname.
 *
 * Só "localhost" não bastava: ao abrir o cardápio de um tablet/celular na LAN
 * (http://192.168.x.x:8081), o front local acabava conversando com a API de
 * PRODUÇÃO — o que, além de não testar nada local, faz "Adicionar ao pedido"
 * criar pedido de verdade. Faixas de IP privado nunca são produção, então a
 * detecção por hostname é segura.
 */
export function isDevHost(host = window.location.hostname) {
    return host === 'localhost'
        || host === '127.0.0.1'
        || /^10\./.test(host)
        || /^192\.168\./.test(host)
        || /^172\.(1[6-9]|2\d|3[01])\./.test(host);
}
